/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { deploymentApmResetSecretTokenUrl } from '@modules/cloud-api/v1/urls'

import { ThunkDispatch, ThunkAction } from '@/types/redux'

import asyncRequest from '../asyncRequests'
import { fetchDeployment } from '../stackDeployments/crud'
import { RESET_APM_TOKEN } from '../../constants/actions'

export function stackDeploymentResetApmToken({
  deploymentId,
  refId,
}: {
  deploymentId: string
  refId: string
}): ThunkAction {
  return (dispatch: ThunkDispatch) => {
    const url = deploymentApmResetSecretTokenUrl({ deploymentId, refId })

    return dispatch(
      asyncRequest({
        type: RESET_APM_TOKEN,
        url,
        method: `POST`,
        meta: { deploymentId, refId },
      }),
    ).then(() => dispatch(fetchDeployment({ deploymentId })))
  }
}
